import { useTranslation } from 'react-i18next';

export const Reviews = () => {
  const { t } = useTranslation();
  const reviews = t('reviews.items', { returnObjects: true });
  return (
    <section aria-labelledby="reviews-title" className="mx-auto max-w-content px-4 py-10 md:px-6 md:py-[60px]" data-testid="reviews-section">
      <h2 id="reviews-title" className="text-center font-heading text-[clamp(32px,3.6vw,48px)] font-extrabold leading-none tracking-[-0.035em]">
        {t('reviews.title')}
      </h2>
      <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
        {reviews.map((r, i) => (
          <figure key={r.name} data-testid={`review-card-${i}`} className="m-0 flex flex-col gap-[18px] rounded-card bg-candy-surface p-7">
            <span className="text-xl tracking-[2px] text-accent" role="img" aria-label={t('reviews.stars')}>
              ★★★★★
            </span>
            <blockquote className="m-0 flex-1 text-lg leading-normal">“{r.text}”</blockquote>
            <figcaption className="font-bold">{r.name}</figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};
